<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1" id="Mercurys_Rise-6.html" xml:lang="en-US">
<div class="calibre1">
<p class="ct" id="toc_marker-7"><a href="#/OEBPS/Mercurys_Rise2#Contents-A">Map</a></p>
<p class="fp"><img alt="MercuryManitouMap.jpg" class="image2" src="OEBPS/images/MercuryManitouMap_fmt.jpeg"/></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Mercurys_Rise-6.vue?be9ec44e